module.exports = __webpack_public_path__ + "img/hk_room_floorplan_09.9bfe01a6.png";